import { Fragment, useEffect, useState } from 'react';
import classes from './register-textbox.module.css';
import { StringUtils } from '../../../utils/helper_functions';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import useInput from './hooks/input-hook';

interface RegisterTextBoxProps {
  type: string;
  id: string;
  value?:string;
  placeholder: string;
  onFocus?: () => void; // Optional event handler for focus
  readOnly?: boolean; // To make the input read-only
  isCalendarEnabled?: boolean;
  InvalidMessage?: string;
  validateFunction: (enteredValue: string) => {isValid:boolean,errorMessage:string};
  onValidationChange: (isValid: boolean, reset: () => void,value?:string) => void; 
}

const RegisterTextBox: React.FC<RegisterTextBoxProps> = (props) => {

  const {value: enteredValue ,isValid,errorMessage, hasError,valueChangeHandler,inputBlurHandler,reset} = useInput({ initialValue:'', validateValue: props.validateFunction });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

   useEffect(() => {
    props.onValidationChange(isValid, reset,enteredValue);
  }, [isValid, reset, props,enteredValue]);
  
  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
  };

  const isPasswordField = props.type === 'password';


  return (
    <Fragment>
      <div className={classes['label-wrapper']}>
        <label className={classes.label}  htmlFor={props.id}>{StringUtils.capitalizeFirstLetter(props.id)}</label>
      </div>
      <div className={classes['input-wrapper']}>
        <input
          type={isPasswordField && isPasswordVisible ? 'text' : props.type}
          id={props.id}
          name={props.id}
          className={classes.textbox}
          placeholder={props.placeholder}
          value={props.value??enteredValue} // Controlled input
          onFocus={props.onFocus} // Trigger calendar or other functionality
          onChange={valueChangeHandler} // Update parent component if needed
          readOnly={props.readOnly} // For calendar-enabled textboxes
          onBlur={inputBlurHandler}
        />
        {isPasswordField && (
          <span
            className={classes['icon-wrapper']}
            onClick={togglePasswordVisibility}
            role="button"
            aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}
          >
            {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
          </span>
        )}
      </div>
      {((props.InvalidMessage?.toLowerCase().includes("username")&& props.id ==="username")||(props.InvalidMessage?.toLowerCase().includes("email") &&props.id ==="email"))?(<p className={classes["error-text"]}>{props.InvalidMessage}</p>):(hasError ? <p className={classes["error-text"]}>{errorMessage}</p>:<p></p>)}

    </Fragment>
  );
};

export default RegisterTextBox;
